import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

export const SUPPORTED_LANGUAGES = ['pt_BR', 'en_US', 'es_MX'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const FALLBACK_LANGUAGE: SupportedLanguage = 'pt_BR';
export const LOCALE_KEY = 'locale';

/** Retorna um idioma suportado ou o fallback. Função pura, sem side effects. */
export function resolveLanguage(raw: string | null | undefined): SupportedLanguage {
  if (raw && (SUPPORTED_LANGUAGES as readonly string[]).includes(raw)) {
    return raw as SupportedLanguage;
  }
  return FALLBACK_LANGUAGE;
}

function readLocaleFromStorage(): string | null {
  try {
    return localStorage.getItem(LOCALE_KEY);
  } catch {
    return null;
  }
}

const i18nInstance = i18next.createInstance();

void i18nInstance
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    lng: resolveLanguage(readLocaleFromStorage()),
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: { escapeValue: false },
    backend: { loadPath: '/assets/i18n-react/{{lng}}.json' },
  });

export default i18nInstance;
